export default __webpack_public_path__ + "static/media/EEG.d9a0b0a4.png";